var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.comSubTypeList[_vm.comSubType],{ref:"nav",tag:"component",attrs:{"refreshPeriod":_vm.refreshPeriod}})}
var staticRenderFns = []

export { render, staticRenderFns }